export default "__VITE_ASSET__5A5H46$r__"